import { render } from "./ImageTemplateMessageView.vue?vue&type=template&id=1819a728&scoped=true"
import script from "./ImageTemplateMessageView.vue?vue&type=script&lang=js"
export * from "./ImageTemplateMessageView.vue?vue&type=script&lang=js"

import "./ImageTemplateMessageView.vue?vue&type=style&index=0&id=1819a728&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1819a728"]])

export default __exports__